/**
 * @generated SignedSource<<0fe38090b498f56a6896bae60efc1efe>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RowWithDragAndDrop_rules$data = {
  readonly " $fragmentSpreads": FragmentRefs<"RowInner_rules">;
  readonly " $fragmentType": "RowWithDragAndDrop_rules";
};
export type RowWithDragAndDrop_rules$key = {
  readonly " $data"?: RowWithDragAndDrop_rules$data;
  readonly " $fragmentSpreads": FragmentRefs<"RowWithDragAndDrop_rules">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "RowWithDragAndDrop_rules",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "RowInner_rules"
    }
  ],
  "type": "JiraFormattingRuleConnection"
};

(node as any).hash = "411d45a42f6096614da4ec8427974ed3";

export default node;
